import { sortByPropertyAlphabetic } from "./sort-fns";

// set a custom sort order for a specific set of type codes
export const customSortOrder = (typeCodes: any[], databaseTable: string) => {
	if (databaseTable === "BuilderAssociation") {
		return typeCodes.sort(sortByPropertyAlphabetic("associationName"));
	} else {
		return typeCodes;
	}
};
